export const totalCountTooltipLabel = "CWARYb";
export const totalCountUnreadCountTooltipLabel = "oKHuEe";
export const totalCountContextMenuLabel = "Jva5mc";
export const totalCountUnreadCountContextMenuLabel = "ZSUSwd";
export default {totalCountTooltipLabel,totalCountUnreadCountTooltipLabel,totalCountContextMenuLabel,totalCountUnreadCountContextMenuLabel};